import * as ACTION_TYPES from "./action_types";

export const SUCCESS = {
  type: ACTION_TYPES.SUCCESS,
};

export const FAILURE = {
  type: ACTION_TYPES.FAILURE,
};

export const success = () => {
  return {
    type: ACTION_TYPES.SUCCESS,
  };
};

export const failure = () => {
  return {
    type: ACTION_TYPES.FAILURE,
  };
};

export const login_success = () => {
  return {
    type: ACTION_TYPES.LOGIN_SUCCESS,
  };
};

export const login_failure = () => {
  return {
    type: ACTION_TYPES.LOGIN_FAILURE,
  };
};

export const add_profile = (profile) => {
  return {
    type: ACTION_TYPES.ADD_PROFILE,
    payload: profile,
  };
};

export const remove_profile = () => {
  return {
    type: ACTION_TYPES.REMOVE_PROFILE,
  };
};

export const user_input_change = (text) => {
  return {
    type: ACTION_TYPES.USER_INPUT_CHANGE,
    payload: text,
  };
};

export const user_input_submit = (text) => {
  return {
    type: ACTION_TYPES.USER_INPUT_SUBMIT,
    payload: text,
  };
};

export const navigate_to = (target) => {
  return {
    type: ACTION_TYPES.NAVIGATE,
    payload: target,
  };
};

export const reset_navigate = () => {
  return {
    type: ACTION_TYPES.RESET_NAVIGATE,
  };
};



export const toggle_ui_filter = (target) => {
    return {
        type: ACTION_TYPES.TOGGLE_UI_FILTER,
        payload: target,
    };
};

export const setActiveSource = (data) => {
  return {
    type: ACTION_TYPES.SET_ACTIVE_SOURCE,
    payload: data,
  };
};

export const setSources = (data) => {
    return {
        type: ACTION_TYPES.SET_SOURCES,
        payload: data
    }
}

export const get_reports = (data) => {
  return {
      type: ACTION_TYPES.GET_REPORTS,
      payload: data
  }
}

export const get_reports_dashboard = (data) => {
  return {
      type: ACTION_TYPES.GET_REPORTS_DASHBOARD,
      payload: data
  }
}

export const setLibtexts = (data) => {
  return {
      type: ACTION_TYPES.SET_LIBTEXTS,
      payload: data
  }
}

export const setSearchedSources = (data) => {
  return {
      type: ACTION_TYPES.SET_SEARCHED_SOURCES,
      payload: data
  }
}

export const get_report_markup = (data) => {
  return {
    type: ACTION_TYPES.GET_REPORT_MARKUP,
    payload: data
  }
}

export const set_text_overlay = (data) => {
  return {
    type: ACTION_TYPES.SET_TEXT_OVERLAY,
    payload: data
  }
}

export const set_overlay_statistics = (data) => {
  return {
    type: ACTION_TYPES.SET_OVERLAY_STATISTICS,
    payload: data
  }
}

export const get_report = (data) => {
  return {
    type: ACTION_TYPES.GET_REPORT,
    payload: data
  }
}

export const get_library = (data) => {
  return {
    type: ACTION_TYPES.GET_LIBRARY,
    payload: data
  }
}
export const get_report_status = (data) => {
  return {
    type: ACTION_TYPES.GET_REPORT_STATUS,
    payload: data
  }
}

export const openToast = (data) => {
  return {
    type: ACTION_TYPES.OPEN_TOASTR,
    payload: { type: "success", status: true, ...data }
  }
}

export const setSourceMarkup = (data) => {
  return {
    type: ACTION_TYPES.SET_SOURCE_MARKUP,
    payload: data
  }
} 

export const change_report_card = (reportId) => {
  return {
    type: ACTION_TYPES.CHANGE_REPORT_CARD,
    payload: reportId,
  };
};

export const change_library_card = (reportId) => {
  return {
    type: ACTION_TYPES.CHANGE_LIBRARY_CARD,
    payload: reportId,
  };
};

export const get_projects = (data) => {
  return {
    type: ACTION_TYPES.GET_PROJECT,
    payload: data,
  };
};

export const get_projects_filter = (data) => {
  return {
    type: ACTION_TYPES.GET_PROJECT_FILTER,
    payload: data,
  };
};

export const reset_report = (data) => {
  return {
    type: ACTION_TYPES.RESET_REPORT,
    payload: data
  }
}

export const get_report_status_message = (data) => {
  return {
    type: ACTION_TYPES.GET_REPORT_STATUS_MESSAGE,
    payload: data
  }
}

export const setSourceFilter = (data) => {
  return {
    type: ACTION_TYPES.SET_SOURCE_FILTER,
    payload: data
  }
}

export const clear_report_filter = () => {
  return {
    type: ACTION_TYPES.CLEAR_REPORT_FILTER
  }
}
export const clear_project_filter = () => {
  return {
    type: ACTION_TYPES.CLEAR_PROJECT_FILTER
  }
}

export const clear_library_filter = () => {
  return {
    type: ACTION_TYPES.CLEAR_LIBRARY_FILTER
  }
}

export const apply_report_filter = (data) => {
  return {
    type: ACTION_TYPES.APPLY_REPORT_FILTER,
    payload: data
  }
}

export const apply_project_filter = (data) => {
  return {
    type: ACTION_TYPES.APPLY_PROJECT_FILTER,
    payload: data
  }
}

export const apply_library_filter = (data) => {
  return {
    type: ACTION_TYPES.APPLY_LIBRARY_FILTER,
    payload: data
  }
}



export const openPaymentDialog = (data) => {
  return {
    type: ACTION_TYPES.OPEN_PAYMENT_DIALOG,
    payload: data
  }
}


export const set_credit_data = (key ,data) => {
  return {
    type: ACTION_TYPES.SET_CREDIT_DATA,
    payload: {key ,data}
  }
}
export const set_project_data = (data) => {
  return {
    type: ACTION_TYPES.SET_PROJECT_DATA,
    payload: {data}
  }
}
export const setOrders = (data) => {
  return {
    type: ACTION_TYPES.SET_ORDERS,
    payload: data
  }
}

export const set_chosen_projects = (data) => {
  return {
    type: ACTION_TYPES.SET_CHOSEN_PROJECTS,
    payload: {data}
  }
}

export const input_url_popup = (data) => {
  return {
    type: ACTION_TYPES.INPUT_URL_POPUP,
    payload: data
  }
}
export const create_project_popup = (data) => {
  return {
    type: ACTION_TYPES.CREATE_PROJECT_POPUP,
    payload: data
  }
}

export const set_properties_form_data = (data) => {
  return {
    type: ACTION_TYPES.SET_PROPERTIES_FORM_DATA,
    payload: data
  }
}

export const setUploadedFiles = (data) => {
  return {
    type: ACTION_TYPES.SET_UPLOADED_FILES,
    payload: data
  }
}

export const setUploadedFilesStatus = (data) => {
  return {
    type: ACTION_TYPES.SET_UPLOADED_FILES_STATUS,
    payload: data
  }
}

export const cancelFilesUpload = () => {
  return {
    type: ACTION_TYPES.CANCEL_FILES_UPLOAD,
  }
}

export const removeUploadedFile = (id) => {
  return {
    type: ACTION_TYPES.REMOVE_UPLOADED_FILE,
    payload: id
  }
}

export const setLanguage = (lang) => {
  return {
    type: ACTION_TYPES.SET_LANGUAGE,
    payload: lang
  }
}

export const resetNewCheckSettings = () => {
  return {
    type: ACTION_TYPES.RESET_NEWCHECK_SETTINGS,
  }
}

export const handle_performace_check = (activeList) => {
  return {
    type: ACTION_TYPES.PERFORMANCE_CHECK_LIST,
    payload: activeList
  }
}

export const change_pagination = (data) => {
  return {
    type: ACTION_TYPES.HANDLE_PAGINATION,
    payload: data
  }
}

export const change_library_pagination = (data) => {
  return {
    type: ACTION_TYPES.HANDLE_LIBRARY_PAGINATION,
    payload: data
  }
}

export const change_project_pagination = (data) => {
  return {
    type: ACTION_TYPES.HANDLE_PROJECT_PAGINATION,
    payload: data
  }
}

export const selected_row_table = (data) => {
  return {
    type: ACTION_TYPES.SELECTED_ROW_TABLE,
    payload: data
  }
}

export const clearReportData = () => {
  return {
    type: ACTION_TYPES.CLEAR_REPORT_PERFORMACE_DATA,
  }
}

export const notifyReportsChanged = () => {
  return {
    type: ACTION_TYPES.NOTIFY_REPORTS_CHANGED,
  }
}

export const notifyLicenseUsersChanged = () => {
  return {
    type: ACTION_TYPES.NOTIFY_LICENSEUSERS_CHANGED,
  }
}

export const notifyLibrariesChanged = () => {
  return {
    type: ACTION_TYPES.NOTIFY_LIBRARIES_CHANGED,
  }
}

export const open_confirmation_popup = (data) => {
  return {
    type: ACTION_TYPES.OPEN_CONFIRMATION_POPUP,
    payload: data
  }
}

export const openConfirmationDialog = (data) => {
  return {
    type: ACTION_TYPES.OPEN_CONFIRMATION_DIALOG,
    payload: data
  }
}

export const openLogDialog = (data) => {
  return {
    type: ACTION_TYPES.OPEN_LOG_DIALOG,
    payload: data
  }
}

export const openPasteDialog = (data) => {
  return {
    type: ACTION_TYPES.OPEN_PASTE_DIALOG,
    payload: data
  }
}

export const closeConfirmationDialog = () => {
  return {
    type: ACTION_TYPES.CLOSE_CONFIRMATION_DIALOG
  }
}

export const closeLogDialog = () => {
  return {
    type: ACTION_TYPES.CLOSE_LOG_DIALOG
  }
}

export const closePasteDialog = () => {
  return {
    type: ACTION_TYPES.CLOSE_PASTE_DIALOG
  }
}

export const set_properties_data_value = (data) => {
  return {
    type: ACTION_TYPES.SET_PROPERTIES_DATA_VALUE,
    payload: data
  }
}

export const changeReportSelection = (selectedReportIds) => {
  return {
    type: ACTION_TYPES.CHANGE_REPORT_SELECTION,
    payload: selectedReportIds
  }
}

export const changeProjectSelection = (selectedProject) => {
  return {
    type: ACTION_TYPES.CHANGE_PROJECT_SELECTION,
    payload: selectedProject
  }
}

export const setCollusion = (collusion) => {
  return {
    type: ACTION_TYPES.SET_COLLUSION,
    payload: collusion
  }
}


export const changeLibrarySelection = (selectedLibraryIds) => {
  return {
    type: ACTION_TYPES.CHANGE_LIBRARY_SELECTION,
    payload: selectedLibraryIds
  }
}

export const setActiveReport = (activeReportId) => {
  return {
    type: ACTION_TYPES.SET_ACTIVE_REPORT,
    payload: activeReportId
  }
}

export const setActiveLibrary = (activeLibraryId) => {
  return {
    type: ACTION_TYPES.SET_ACTIVE_LIBRARY,
    payload: activeLibraryId
  }
}

export const setDraftReport = (properties) => {
  return {
    type: ACTION_TYPES.SET_DRAFT_REPORT,
    payload: properties
  }
}

export const setDraftProject = (properties) => {
  return {
    type: ACTION_TYPES.SET_DRAFT_PROJECT,
    payload: properties
  }
}

export const setDraftLibrary = (properties) => {
  return {
    type: ACTION_TYPES.SET_DRAFT_LIBRARY,
    payload: properties
  }
}

export const setCheckoutDetails = (props) => {
  return {
    type: ACTION_TYPES.SET_CHECKOUT_DETAILS,
    payload: props
  }
}

export const setUserDetails = (props) => {
  return {
    type: ACTION_TYPES.SET_USER_DETAILS,
    payload: props
  }
}

export const setExcludeSources = (key ,data) => {
  return {
    type: ACTION_TYPES.SET_EXCLUDE_SOURCES,
    payload: {key ,data}
  }
}

export const setAcceptSource = (key ,data) => {
  return {
    type: ACTION_TYPES.SET_ACCEPT_SOURCE,
    payload: {key ,data}
  }
}

export const set_message_list = (data) => {
  return {
      type: ACTION_TYPES.SET_MESSAGE_LIST,
      payload: data
  }
}

export const get_report_statistics_by_project = (data) => {
  return {
      type: ACTION_TYPES.GET_REPORT_STATISTICS_BY_PROJECT,
      payload: data
  }
}

export const get_report_statistics_by_month = (data) => {
  return {
      type: ACTION_TYPES.GET_REPORT_STATISTICS_BY_MONTH,
      payload: data
  }
}

export const get_news = (data) => {
  return {
      type: ACTION_TYPES.GET_NEWS,
      payload: data
  }
}

export const get_faqs = (data) => {
  return {
      type: ACTION_TYPES.GET_FAQS,
      payload: data
  }
}


export const notifyProjectsChanged = () => {
  return {
    type: ACTION_TYPES.NOTIFY_PROJECTS_CHANGED,
  }
}

export const showFullscreenLoading = (visible, text = null) => {
  return {
    type: ACTION_TYPES.SHOW_FULLSCREEN_LOADING,
    payload: { visible, text}
  }
}

export const setUI = (data) => {
  return {
    type: ACTION_TYPES.SET_UI,
    payload: data 
  }
}

export const setCreditCosts = (data) => {
  return {
    type: ACTION_TYPES.SET_CREDIT_COSTS,
    payload: data 
  }
}

export const setNewCheckSettings = (data) => {
  return {
    type: ACTION_TYPES.SET_NEWCHECK_SETTINGS,
    payload: data 
  }
}

export const setNewTextSettings = (data) => {
  return {
    type: ACTION_TYPES.SET_NEWTEXT_SETTINGS,
    payload: data 
  }
}


export const setUserSettings = (data) => {
  return {
    type: ACTION_TYPES.SET_USER_SETTINGS,
    payload: data 
  }
}

export const openReportDownloadDialog = (reportids) => {
  return {
    type: ACTION_TYPES.OPEN_REPORT_DOWNLOAD_DIALOG,
    payload: reportids 
  }
}

export const setAdminLicense = (data) => {
  return {
    type: ACTION_TYPES.SET_ADMINLICENSE,
    payload: data 
  }
}

export const setMaintenance = (data) => {
  return {
    type: ACTION_TYPES.SET_MAINTENANCE,
    payload: data 
  }
}


